module.exports = __webpack_public_path__ + "static/1-4f4ceef3b49bde4209aa6f0572822ce5.jpg";